export enum SurveyType {
  WORLD_CUP = 'world-cup',
}

export type SurveyResultApiResponse = {
  accountNumber: string
  surveyType: string
  hasCompletedSurvey: boolean
}

export type SurveyParams = {
  surveyType: SurveyType
  accountNumber: string
}
